// loads scripts that need to be on page - every entrypoint should import this!
import './kickstart';

// packages
import { index } from 'd3-array';
import { json } from 'd3-fetch';

// local
import { GEOGRAPHY_URL, RESULTS_URL } from './constants.js';
import { topojsonToGeoJson } from './utils/geography.js';
import { renderSvelteComponent } from './utils/render.js';
import {
  createFeed,
  createRaceFeed,
  createCandidateFeed,
  createCandidateLookup,
  createSubunitLookup,
  indexByApId,
} from './stores.js';

// components
import ChoiceList from './components/ChoiceList.svelte';
import ExpectedVote from './components/ExpectedVote.svelte';
import ResultsList from './components/ResultsList.svelte';
import ResultsMap from './components/ResultsMap.svelte';
import ResultsLegend from './components/ResultsLegend.svelte';

const crosswalk = index(window.CROSSWALK, indexByApId);

// Write your code!
async function main() {
  // raw feed
  const feed = await createFeed(RESULTS_URL);

  // map data
  const topology = await json(GEOGRAPHY_URL);
  const [geography, roads, cities] = topojsonToGeoJson(topology, [
    'counties',
    'roads',
    'cities',
  ]);

  // yes/no recall
  const recallRaceFeed = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-I8808-2021-09-14')
  );
  const recallRaceCandidateLookup = createCandidateLookup(recallRaceFeed);
  const recallRaceSubunitLookup = createSubunitLookup(recallRaceFeed);

  const yesCandidateFeed =
    /** @type {import('./types.d').ReadableCandidate} */ (
      createCandidateFeed(recallRaceFeed, 'polid-2')
    );

  renderSvelteComponent(
    ChoiceList,
    /** @type {HTMLElement} */ (document.getElementById('recall-results-yes')),
    {
      prompt: 'Yes, replace him',
      candidate: yesCandidateFeed,
      race: recallRaceFeed,
    }
  );

  const noCandidateFeed = /** @type {import('./types.d').ReadableCandidate} */ (
    createCandidateFeed(recallRaceFeed, 'polid-3')
  );

  renderSvelteComponent(
    ChoiceList,
    /** @type {HTMLElement} */ (document.getElementById('recall-results-no')),
    {
      prompt: 'No, keep him',
      candidate: noCandidateFeed,
      race: recallRaceFeed,
    }
  );

  renderSvelteComponent(
    ExpectedVote,
    /** @type {HTMLElement} */ (document.getElementById('recall-results-eevp')),
    { race: recallRaceFeed }
  );

  // candidate choice
  const candidateRaceFeed = /** @type {import('./types.d').ReadableRace} */ (
    createRaceFeed(feed, 'CA-G8809-2021-09-14')
  );
  const candidateRaceCandidateLookup = createCandidateLookup(candidateRaceFeed);
  const candidateRaceSubunitLookup = createSubunitLookup(candidateRaceFeed);

  renderSvelteComponent(
    ResultsList,
    /** @type {HTMLElement} */ (
      document.getElementById('candidate-results-container')
    ),
    { race: candidateRaceFeed, crosswalk }
  );

  renderSvelteComponent(
    ResultsMap,
    /** @type {HTMLElement} */ (document.getElementById('recall-results-map')),
    {
      geography,
      roads,
      cities,
      candidates: recallRaceCandidateLookup,
      subunits: recallRaceSubunitLookup,
      includeParty: false,
    }
  );
  renderSvelteComponent(
    ResultsLegend,
    /** @type {HTMLElement} */ (
      document.getElementById('recall-results-legend')
    ),
    {
      race: recallRaceFeed,
    }
  );

  renderSvelteComponent(
    ResultsMap,
    /** @type {HTMLElement} */ (
      document.getElementById('candidate-results-map')
    ),
    {
      geography,
      roads,
      cities,
      candidates: candidateRaceCandidateLookup,
      subunits: candidateRaceSubunitLookup,
      includeParty: true,
    }
  );
  renderSvelteComponent(
    ResultsLegend,
    /** @type {HTMLElement} */ (
      document.getElementById('candidate-results-legend')
    ),
    {
      race: candidateRaceFeed,
    }
  );
}

main().catch(console.error);
